import { render } from "./GameCard.vue?vue&type=template&id=7a4c3a3c"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"
script.render = render

export default script